import React, { memo } from "react";
import { textStyleSet } from "../../../../../../mui-theme/text.style";
import { OnboardingTrainingWidgetComponent } from "../onboarding-training-widget";
import { useOnboardingTrainingSection } from "./onboarding-training-section.hook";
import { OnboardingTrainingSectionProps } from "./onboarding-training-section.types";
import { IconFontLayer } from "../../../../../../icon-font/iconfont-layer";
import { color } from "../../../../../../mui-theme/palette";
import { IconFont } from "../../../../../../icon-font/iconfont";
import { OnboardingTrainingPlatform } from "../../../course-menu-screen/type";
import styles from "../../candidate-home.module.css";
// import trainingLogo from "../../../../../../components/icon/assets/training.svg"; // PHKL Custom
import trainingLogo from "../../../../../../components/icon/assets/orientation-cource.svg"; // PHKL Custom
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next"; // PHKL Custom

export const OnboardingTrainingSectionComponent: React.FC<OnboardingTrainingSectionProps> = memo(
  (props: OnboardingTrainingSectionProps) => {
    const { t } = useTranslation(); // PHKL Custom
    const { type = "card", onClick } = props;
    const {
      displayedCourses,
      loading,
      error,
      isExpanded,
      showViewMore,
      onboardingTrainingShouldShow,
      onboardingTrainingIsActive,
      trainingPlatform,
      handleToggleExpand,
      handleSSOClick,
      translations,
    } = useOnboardingTrainingSection();

    const trainingAndExamSummary = useSelector(
      // DONOT use useSelector(selectOnboardingTrainingSummary), because it rewrites the object make it not empty
      (state: any) => state.onboarding.trainingAndExamSummary,
    );

    // If onboarding training should not show at all, don't render anything
    if (!onboardingTrainingShouldShow) {
      return null;
    }

    if (isEmpty(trainingAndExamSummary)) {
      return null;
    }

    // Only render NEW platform content
    if (trainingPlatform !== OnboardingTrainingPlatform.NEW) {
      return null;
    }

    // PHKL Custom -s

    // only render onboarding active content
    if (!onboardingTrainingIsActive || displayedCourses.length === 0) {
      return null;
    }

    // PHKL Custom -e

    // Handle shortcut mode
    if (type === "shortcut") {
      return (
        <div className={styles.actionItem} onClick={onClick || (() => handleSSOClick())}>
          <img src={trainingLogo} alt="" className={styles.actionIcon} />
          <span className={styles.text}>{translations.title}</span>
        </div>
      );
    }
    // PHKL Custom -s
    // COE Original Layout
    // // Handle card mode
    // return (
    //   <div className="py-3">
    //     <div className="flex flex-row items-center mb-3 mx-4">
    //       <p className="text-grey33 flex-1" style={textStyleSet.text_18_bold}>
    //         {/*  // PHKL Custom -s */}
    //         {/* {translations.title}  */}
    //         {translations.progress}
    //         {/*  // PHKL Custom -e */}
    //       </p>
    //     </div>

    //     {/* Loading state */}
    //     {loading && (
    //       <div className="flex justify-center items-center py-8">
    //         <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue"></div>
    //       </div>
    //     )}

    //     {/* Error state */}
    //     {error && !loading && (
    //       <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
    //         <p className="text-red-600 text-sm">{error}</p>
    //       </div>
    //     )}

    //     {/*  // PHKL Custom -s */}
    //     {/* Inactive training state */}
    //     {/* {!loading && !error && !onboardingTrainingIsActive && (
    //       <div
    //         // PHKL Custom -s
    //         className="mb-4 bg-white rounded-xl flex flex-row items-center"
    //         style={{ backgroundColor: color.white, padding: 12 }}
    //         // PHKL Custom -e
    //       >
    //         <IconFontLayer
    //           size={36}
    //           backgroundSize={56}
    //           containerStyle={{
    //             borderRadius: 12,
    //             borderWidth: 0,
    //             backgroundColor: color.redLightest,
    //           }}
    //           // name="tabbar_taining_normal" // PHKL Custom
    //           name="a-mockexam" // PHKL Custom
    //           color={color.majorRed}
    //         />
    //         <div className="flex flex-1 flex-col justify-center ml-3">
    //           <div className="flex flex-row items-center">
    //             <p className="text-grey33 flex-1" style={textStyleSet.text_16_med}>
    //               {translations.inactive}
    //             </p>
    //           </div>
    //         </div>
    //       </div>
    //     )} */}

    //     {/* Empty state when no courses and not loading and training is active */}
    //     {!loading && !error && displayedCourses.length === 0 && (
    //       <div
    //         // PHKL Custom -s
    //         className="mb-4 bg-white rounded-xl flex flex-row items-center"
    //         style={{ backgroundColor: color.white, padding: 12 }}
    //         onClick={() => handleSSOClick()}
    //       >
    //         {/* <IconFontLayer
    //           size={36}
    //           backgroundSize={56}
    //           containerStyle={{
    //             borderRadius: 12,
    //             borderWidth: 0,
    //             backgroundColor: color.redLightest,
    //           }}
    //           // name="tabbar_taining_normal" // PHKL Custom
    //           name="a-mockexam" // PHKL Custom
    //           color={color.majorRed}
    //         /> */}

    //         <div
    //           className="flex justify-center items-center"
    //           style={{
    //             width: 56,
    //             height: 56,
    //             backgroundColor: "rgb(255, 228, 230)",
    //             borderWidth: 0,
    //             opacity: 1,
    //             borderRadius: 12,
    //           }}
    //         >
    //           <img src={trainingLogo} alt="" />
    //         </div>
    //         {/* PHKL Custom -e */}
    //         <div className="flex flex-1 flex-col justify-center ml-3">
    //           <div className="flex flex-row items-center">
    //             <p className="text-grey33 flex-1" style={textStyleSet.text_16_med}>
    //               {translations.enroll}
    //             </p>
    //           </div>
    //         </div>
    //       </div>
    //     )}

    //     {/* Course list */}
    //     {!loading && !error && displayedCourses.length > 0 && (
    //       <div>
    //         {displayedCourses.map((course, index) => (
    //           <div key={course.courseId} className="mb-3">
    //             <OnboardingTrainingWidgetComponent
    //               course={course}
    //               onSSOClick={handleSSOClick}
    //               isActivated={onboardingTrainingIsActive}
    //             />
    //           </div>
    //         ))}

    //         {/* View More/Less button */}
    //         {showViewMore && (
    //           <div className="flex justify-center">
    //             <button onClick={handleToggleExpand} className="flex items-center">
    //               <span style={textStyleSet.text_14_med} className="text-grey66 mr-1">
    //                 {isExpanded ? translations.viewLess : translations.viewMore}
    //               </span>
    //               <span className={`${isExpanded ? "inline-block rotate-180" : "inline-block"}`}>
    //                 <IconFont size={24} name={"arrow_down"} color={color.grey66} />
    //               </span>
    //             </button>
    //           </div>
    //         )}
    //       </div>
    //     )}

    //     {/*  // PHKL Custom -e */}
    //   </div>
    // );

    /* PHKL Layout */
    return (
      <div className="px-3 py-2 md:px-0">
        <div className="bg-white rounded-2xl">
          {/* Header */}
          <div className="flex items-center px-4 py-3 border-b border-gray-200">
            <p className="flex-1 text-[20px] font-semibold text-[#1A1A1A] leading-[28px]">
              {translations.progress}
            </p>
          </div>

          {/* Loading state */}
          {loading && (
            <div className="flex justify-center items-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue"></div>
            </div>
          )}

          {/* Error state */}
          {error && !loading && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-600 text-sm">{error}</p>
            </div>
          )}

          {/* Course list */}
          {!loading && !error && displayedCourses.length > 0 && (
            <div>
              {displayedCourses.map((course, index) => (
                <div
                  key={course.courseId}
                  className={`${index !== 0 ? "border-t border-gray-200" : ""}`}>
                  <OnboardingTrainingWidgetComponent
                    course={course}
                    onSSOClick={handleSSOClick}
                    isActivated={onboardingTrainingIsActive}
                  />
                </div>
              ))}

              {/* View More/Less button */}
              {showViewMore && (
                <div className="flex justify-center border-t border-gray-200">
                  <button onClick={handleToggleExpand} className="flex items-center">
                    <span style={textStyleSet.text_14_med} className="text-grey66 mr-1">
                      {isExpanded ? translations.viewLess : translations.viewMore}
                    </span>
                    <span className={`${isExpanded ? "inline-block rotate-180" : "inline-block"}`}>
                      <IconFont size={24} name={"arrow_down"} color={color.grey66} />
                    </span>
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
    // PHKL Custom -e
  },
);
